import { apiClient } from './apiClient';

export interface PostCategory {
  id: number;
  name: string;
  description?: string;
}

export interface PostCategoryListResponse {
  code: number;
  message: string;
  data: PostCategory[];
}

// 게시글 카테고리 목록 조회
export const getPostCategories = async (): Promise<PostCategoryListResponse> => {
  try {
    /// console.log('게시글 카테고리 목록 조회 API 호출');
    
    const { data: result } = await apiClient.get<PostCategoryListResponse>(
      '/api/post-categories/list',
      { withCredentials: true }
    );
    
    /// console.log('게시글 카테고리 API 응답:', {result});
    
    if (result.code !== 200) {
      throw new Error(`API error: ${result.message}`);
    }

    return result;
  } catch (error) {
    /// console.error('게시글 카테고리 목록 조회 실패:', error);
    throw error;
  }
};
